import { z } from 'zod';

/**
 * `PUT /api/source-control/forges`: one of the user's code forges, all active at once. `on` turns
 * a forge on or off; `host` makes it the forge a host's repositories go to when several serve it
 * (`plugin: null` gives that host back to the core's order).
 */
export const codeForgeChangeSchema = z.union([
  z.object({ plugin: z.string().min(1).max(256), on: z.boolean() }).strict(),
  z
    .object({
      host: z.string().min(1).max(260),
      plugin: z.string().min(1).max(256).nullable(),
    })
    .strict(),
]);
export type CodeForgeChange = z.infer<typeof codeForgeChangeSchema>;
